import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type Props = {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  id?: string;
};
export function CtaButton({
  children,
  variant = 'primary',
  id
}: Props) {
  const base = 'group inline-flex w-full items-center justify-center gap-3 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out active:scale-[0.98] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-grass-400/40 sm:text-lg sm:px-8 sm:py-5';
  const styles = variant === 'primary' ? 'bg-grass-500 text-white shadow-[0_10px_0_0_#0F8B5C] hover:bg-grass-400 hover:shadow-[0_8px_0_0_#0F8B5C]' : 'border-2 border-navy-800 bg-white text-navy-800 shadow-[0_8px_0_0_#0D2240] hover:bg-navy-50';
  return <a id={id} href={CHECKOUT_URL} className={`${base} ${styles}`} data-id="element-28" data-mp="15ahnioc1cyer">
      <CheckCircle2Icon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-29" data-mp="35xfo76wcd5aa" />
      <span data-id="element-30" data-mp="35zin6gfh28r5">{children}</span>
    </a>;
}